import { Component, OnInit, ViewChild } from '@angular/core';
import { Delegate } from 'src/app/entity/Delegate';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { DelegateService } from 'src/app/service/delegate.service';
import { ProspectService } from 'src/app/service/prospect.service';
import { DiverBadgeService } from 'src/app/service/firebase/diver-badge.service';
import { MailsService } from 'src/app/service/mails.service';
import { SonatrachService } from 'src/app/service/firebase/sonatrach.service';

@Component({
  selector: 'app-sonatrach',
  templateUrl: './sonatrach.component.html',
  styleUrls: ['./sonatrach.component.css']
})
export class SonatrachComponent implements OnInit {
  cols: { field: string; header: string; }[];
  loading: boolean;
  delgates: Delegate[];
  selectedDelegate: Delegate;
  exportColumns: { title: string; dataKey: string; }[];
  loadByOrder: boolean;

  uploadedFiles: any[];
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;
  loaded: number;

  constructor(private delegateService: DelegateService
    , private prospectService: ProspectService,
    private sonatrachService: SonatrachService, private mailsService: MailsService) {

      this.sychronier();
  }

  ngOnInit() {


    this.cols = [

      { field: 'nom', header: 'Name' },
      { field: 'position', header: 'Position' },
      { field: 'entreprise', header: 'Company' },
      { field: 'mail', header: 'Email' },
      { field: 'mobile', header: 'Mobile' },

      { field: 'description', header: 'Type of Pass' },
      { field: 'pays', header: 'Country' },
      { field: 'note', header: 'Note' },
      { field: 'status', header: 'Status' }
    ];



    let colsExport = [

      { field: 'nom', header: 'Name' },
      { field: 'position', header: 'Position' },
      { field: 'entreprise', header: 'Company' },

      { field: 'pays', header: 'Country' }
    ];
    this.exportColumns = colsExport.map(col => ({ title: col.header, dataKey: col.field }));
    this.loadAll();
    
  }

  loadAll() {
    //console.log("this.loadByOrder " + this.loadByOrder);

    if (!this.loadByOrder)
      this.delegateService.getAllDelegateEntities().subscribe(result => {

      
        this.delgates=[];
result.forEach(element => {
  if(element.uid=="Sonatrach")
  this.delgates.push(element)
});
      })
    else
      this.delegateService.orederByDelegate().subscribe(result => {

        
this.delgates=[];
result.forEach(element => {
  if(element.uid=="Sonatrach")
  this.delgates.push(element)
});


      })

  }
  columns: any[];
  exportPdf() {
    /*
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        // @ts-ignore
        const doc = new jsPDF.default(0, 0);
        // @ts-ignore
        doc.autoTable(this.exportColumns, this.delgates);
        doc.save('delegateNAPEC2020.pdf');
      })
    })
    */
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.delgates);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  blur(row: Delegate) {
    if (row && row.idDelegate) {


      this.delegateService.updateDelegate(row).subscribe(result => {

        this.loadAll();
      })
    }
  }

  editNote(row: Delegate) {
    if (row && row.idDelegate) {


      this.delegateService.updateDelegate(row).subscribe(result => {


      })
    }
  }

  printBadge() {
    this.delegateService.print(this.selectedDelegate).subscribe(
      (res: any) => {

        var filename = 'restfile.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);

      }


    )
  }

  status(stausSent: string) {
    this.selectedDelegate.status = stausSent;
    this.delegateService.updateDelegate(this.selectedDelegate).subscribe(result => {
      this.loadAll()
    })
  }


  sendLinkEBAdge(nbr: number) {


    this.uploadedFiles = []





    this.mailsService.findodel(nbr).subscribe(model => {
      let idEncrypt = this.selectedDelegate.idClient * 4560;


      model.corp = model.corp.replace("@link@", 'https://badgesnapec.firebaseapp.com/badges/badgesclient' + idEncrypt)
      this.composeMailComponent.prepareEmailModelDelegate(model, this.selectedDelegate, [])
    })




  }
  sendEBAdge(nbr: number) {


    this.uploadedFiles = []
    this.delegateService.print(this.selectedDelegate).subscribe(
      (res) => {
        var filename = this.selectedDelegate.nom + 'badge.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '');
        res.name = filename;
        this.uploadedFiles.push(res);


        this.mailsService.findodel(nbr).subscribe(result => {

          this.composeMailComponent.prepareEmailModelDelegate(result, this.selectedDelegate, this.uploadedFiles)
        })

      }
    );

  }

  gotoBadges(id: number) {

 


    window.open('https://badgesnapec.firebaseapp.com/Fc3A4bzFk1qWpJZkoOri8Q'  , '_blank');


  }


  sychronier() {
    //console.log("importation");

    let a = this.sonatrachService.getAllBadgesNotImported().subscribe(result => {
      //console.log("importation  11111" + JSON.stringify(result));
      a.unsubscribe();
      if (result) {
        let nbr = result.length;
        let loadedloca = nbr;
        //console.log("nbrrr " + nbr);


        result.forEach(badge => {


          let delegate = this.sonatrachService.copyFromBadg(badge);
          this.delegateService.addDelegate(delegate).subscribe(result => {
            nbr--;
            badge.imported = true;
            this.sonatrachService.updateBadge(badge.id, badge)
            //console.log("nbrrr0d " + nbr);

            if (nbr == 0) {
              this.loadAll();
              this.loaded = loadedloca;
            }

          })

        });
      }

    })

  }


}




